//
//
//
//
//
//
//

export default {
  created() {},
  mounted() {
    document.dispatchEvent(new Event('render-event'))
  }
}
